import { NotFoundScreen } from 'app/features/not-found/screen'
export default NotFoundScreen
